<template>
  <validation-observer tag="div" ref="form">
    <validation-provider vid="farm_id" :name="lodash.upperFirst($t('jala_ponds.farm'))" rules="required" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('jala_ponds.farm')) + '*'"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <jala-farm-select-ajax
            name="farm_id"
            v-model.number="model.farm_id"
        ></jala-farm-select-ajax>
      </b-form-group>
    </validation-provider>
    <validation-provider vid="name" :name="lodash.upperFirst($t('jala_ponds.name'))" rules="required" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('jala_ponds.name')) + '*'"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <b-form-input
            name="name"
            type="text"
            required
            :state="errors[0] ? false : (validated ? true : null)"
            v-model="model.name"
        ></b-form-input>
      </b-form-group>
    </validation-provider>
    <validation-provider vid="area" :name="lodash.upperFirst($t('jala_ponds.area'))" rules="required|double" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('jala_ponds.area')) + '*'"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <numeral-input
            name="area"
            format="0,0"
            required
            :state="errors[0] ? false : (validated ? true : null)"
            v-model.number="model.area"
        ></numeral-input>
      </b-form-group>
    </validation-provider>
    <validation-provider vid="length" :name="lodash.upperFirst($t('jala_ponds.length'))" rules="required|double" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('jala_ponds.length')) + '*'"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <numeral-input
            name="length"
            required
            :state="errors[0] ? false : (validated ? true : null)"
            v-model.number="model.length"
        ></numeral-input>
      </b-form-group>
    </validation-provider>
    <validation-provider vid="width" :name="lodash.upperFirst($t('jala_ponds.width'))" rules="required|double" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('jala_ponds.width')) + '*'"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <numeral-input
            name="width"
            required
            :state="errors[0] ? false : (validated ? true : null)"
            v-model.number="model.width"
        ></numeral-input>
      </b-form-group>
    </validation-provider>
    <validation-provider vid="deep" :name="lodash.upperFirst($t('jala_ponds.deep'))" rules="double" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('jala_ponds.deep'))"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <numeral-input
            name="deep"
            :state="errors[0] ? false : (validated ? true : null)"
            v-model.number="model.deep"
        ></numeral-input>
      </b-form-group>
    </validation-provider>
    <validation-provider vid="feeding_tray_count" :name="lodash.upperFirst($t('jala_ponds.feeding_tray_count'))" rules="numeric" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('jala_ponds.feeding_tray_count'))"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <numeral-input
            name="feeding_tray_count"
            format="0,0"
            :state="errors[0] ? false : (validated ? true : null)"
            v-model.number="model.feeding_tray_count"
        ></numeral-input>
      </b-form-group>
    </validation-provider>
  </validation-observer>
</template>

<script>
  import FormModel from './model';
  import JalaFarmSelectAjax from "@/components/inputs/jala-farm-select-ajax";

  export default {
    components: {
      JalaFarmSelectAjax
    },
    extends: FormModel,
    data() {
      let vm = this;
      return {
        model: {
          farm_id: this.$route.query.farm_id,
          feeding_tray_count: 4,
          length: 36.51,
          width: 27.39,
          deep: 1.5,
          ...this.value,
          get area () {
            if ((this.length === null) || (this.width === null)) return null;
            return vm.lodash.round((this.length) * (this.width));
          },
          set area (value) {
            vm.$set(this, 'length', vm.lodash.round(4 * Math.sqrt(value / 12), 2));
            vm.$set(this, 'width', vm.lodash.round(3 * Math.sqrt(value / 12), 2));
          }
        },
        selects: {
          timezones: [...Array(27)].map((_, index) => {
            const tz = this.$moment().utcOffset(index - 12).format('Z');
            return { id: tz, label: tz };
          })
        }
      }
    },
    mounted() {
      //
    }
  }
</script>
